import React, { FC, ReactNode, useEffect, useState } from "react";
import { graphql, useStaticQuery } from "gatsby";

import { Box } from "@mui/material";

import Footer from "@components/Footer";
import Header from "@components/Header";
import SiteBanner from "@components/SiteBanner";
import AiChallengeHeader from "@components/Header/aiChallengeHeader";
import { useUTMCodes } from "@src/hooks/utmCodes";
import { UtmParameters } from "@src/helpers/utms";
import AiChallengeFooter from "../Footer/aiChallengeFooter";
import AiChallengeRegisterModal from "../AiChallengeRegisterModal";

interface Props {
  isHome?: boolean;
  reverseColor?: boolean;
  noHeaderBg?: boolean;
  mountOnBuild?: boolean;
  children: ReactNode;
  smallFooter?: boolean;
  fullHeight?: boolean;
  pageContext?: any;
  pageUtms?: UtmParameters;
  challengeUi?: boolean;
}

const MainLayout: FC<Props> = ({
  isHome = false,
  reverseColor = false,
  noHeaderBg = false,
  mountOnBuild = false,
  smallFooter = false,
  fullHeight = false,
  pageContext = {},
  pageUtms = {},
  challengeUi = false,
  children,
}) => {
  const [mounted, setMounted] = useState(false);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
          menuLinks {
            name
            link
            type
            breakoutSubsections
            containerType
            maxWidth
            footerBreak
            subSections {
              name
              layout
              type
              accentColor
              description
              link
              icon
              menuLinks {
                name
                link
                type
                tag
                service
                description
                footerOnly
              }
            }
            menuLinks {
              name
              link
              type
              icon
            }
          }
        }
      }
    }
  `);

  const calculatedPageContext = {
    ...pageContext,
    pageUtms: pageUtms,
  };

  useEffect(() => {
    setMounted(true);
  });

  // Track UTM codes in a cookie
  useUTMCodes();

  if (!mountOnBuild && !mounted) {
    return null;
  }

  return (
    <>
      <SiteBanner />
      <Box
        sx={{
          position: "relative",
        }}
      >
        {challengeUi ? (
          <AiChallengeHeader />
        ) : (
          <Header
            isHome={isHome}
            reverseColor={reverseColor}
            noBackground={noHeaderBg}
            menuLinks={data.site.siteMetadata.menuLinks}
            pageContext={calculatedPageContext}
          />
        )}
        <Box
          sx={{
            alignContent: !fullHeight ? "auto" : "center",
            position: "relative",
          }}
        >
          {children}
        </Box>
        {challengeUi ? (
          <AiChallengeFooter />
        ) : (
          <Footer
            menuLinks={data.site.siteMetadata.menuLinks}
            smallFooter={smallFooter}
          />
        )}
      </Box>
      <AiChallengeRegisterModal />
    </>
  );
};

export default MainLayout;
